import { FileType } from '@office-start/document-types';
var AppNameToFileType = {
    none: FileType.None,
    excel: FileType.Excel,
    fluidapp: FileType.Fluid,
    forms: FileType.Forms,
    onenote: FileType.OneNote,
    powerpoint: FileType.PowerPoint,
    ppt: FileType.PowerPoint,
    stream: FileType.Stream,
    sway: FileType.Sway,
    visio: FileType.Visio,
    word: FileType.Word,
    playlist: FileType.PlayList,
    video: FileType.Stream,
    clipchamp: FileType.Clipchamp,
};
export function getFileTypeFromAppName(fileTypeName) {
    if (!fileTypeName) {
        return;
    }
    return AppNameToFileType[fileTypeName.toLowerCase()];
}
//# sourceMappingURL=getFileTypeFromAppName.js.map